import Image from 'next/image'
import { useState } from 'react'

import * as Styles from './style'
import { FlexRow } from 'styles/styled'
import { Chevron, SettingsSvg } from 'shared/images'

interface FilterDropdownV2Props {
  children?: React.ReactNode
  headerText: string
}

const FilterDropdownV2 = (props: FilterDropdownV2Props) => {
  const { children, headerText } = props
  const [openFilterDropdown, setOpenFilterDropdown] = useState(false)
  return (
    <Styles.FilterDropdownContainer>
      <Styles.FilterDropdownHeader
        show={openFilterDropdown}
        onClick={() => setOpenFilterDropdown(!openFilterDropdown)}
      >
        <FlexRow gap='10px'>
          <Image src={SettingsSvg} alt='settings-icon' />
          <span className='headerText'>{headerText}</span>
        </FlexRow>
        <Image className='dropIcon' src={Chevron} alt='arrow-icon' />
      </Styles.FilterDropdownHeader>
      <Styles.FilterDropdownContent show={openFilterDropdown}>
        {children}
      </Styles.FilterDropdownContent>
    </Styles.FilterDropdownContainer>
  )
}

export default FilterDropdownV2
